<script setup lang="ts">
defineOptions({
  name: "ProfilePage",
});
definePageMeta({
  layout: "account",
});

const { t } = useI18n();

useBreadcrumbs([
  {
    name: t("breadcrumbs.accountOverview"),
    path: "/account",
  },
  {
    name: t("breadcrumbs.myAccount"),
    path: "/account/profile",
  },
]);
</script>

<template>
  <div class="personal-data">
    <div class="title pb-4 border-b border-b-custom-grey">
      <h3
        class="font-bold text-2xl md:text-3xl lg:text-4xl leading-normal mb-4"
      >
        {{ $t("account.yourProfile") }}
      </h3>
      <p class="md:text-lg lg:text-xl text-arsenic font-medium">
        {{ $t("account.profileInfo") }}
      </p>
    </div>

    <div class="relative flex flex-col min-w-0 break-words w-full mb-6">
      <div class="flex-auto">
        <div :class="['cms-block-product-description-reviews__description']">
          <AccountPersonalData />
        </div>
        <div :class="['cms-block-product-description-reviews__description']">
          <AccountPersonalEmail />
        </div>
        <div :class="['cms-block-product-description-reviews__reviews']">
          <AccountChangePassword />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
